import {trans} from '@frontend/helpers'
import type {
    FilteredItemsPageUrlQueryParams,
    ItemsListRouteParams,
    ItemsListSorting,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import {iconSortingSquareOutline} from '@shared/helpers/icons'
import {
    useEffect,
    useEffectEvent,
} from 'react'
import {useParams} from 'react-router-dom'
import {Dropdown} from 'swayok-react-mdb-ui-kit/components/Dropdown/Dropdown'
import {DropdownItem} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownItem'
import {DropdownMenu} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownMenu'
import {DropdownToggle} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownToggle'
import {
    IconButton,
    type IconButtonProps,
} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import {ItemsListSortingOptions} from '../../../../../constants/ItemsListSortingOptions'
import {normalizeSortingForItemFilters} from '../../../../../helpers/convertItemFiltersFromUrlQueryToFiltersForRequest'
import {extractIdFromUrlSlug} from '../../../../../helpers/extractIdFromUrlSlug'
import {shouldShowItemsListSorting} from '../../helpers/shouldShowItemsListSorting'

// Сортировка объявлений.
export function AdsSortDropdown() {
    const routeParams = useParams<ItemsListRouteParams>()
    const {
        setUrlQueryParams,
        urlQueryData,
    } = useUrlQueryParams<FilteredItemsPageUrlQueryParams>()

    const isAllowed = shouldShowItemsListSorting(
        urlQueryData,
        extractIdFromUrlSlug(routeParams.slugWithId)
    )
    const activeSort: ItemsListSorting = normalizeSortingForItemFilters(urlQueryData.sort) ?? 'default'

    // Обновляет параметр сортировки в URL.
    const onChange = (sort: ItemsListSorting) => {
        setUrlQueryParams(params => {
            if (sort === 'default') {
                params.delete('sort')
            } else {
                params.set('sort', sort)
            }
            return params
        })
    }

    // Сбрасывает параметр сортировки в URL.
    const resetSorting = useEffectEvent(() => {
        if (!urlQueryData.sort) {
            // Сортировки и так нет.
            return
        }
        setUrlQueryParams(params => {
            params.delete('sort')
            return params
        }, {replace: true})
    })

    // После снятия последнего фильтра возвращаем исходное ранжирование.
    useEffect(() => {
        if (!isAllowed) {
            resetSorting()
        }
    }, [isAllowed])

    if (!isAllowed) {
        return null
    }

    return (
        <div className="">
            <Dropdown>
                <DropdownToggle<IconButtonProps>
                    tag={IconButton}
                    path={iconSortingSquareOutline}
                    size={22}
                    color="dark"
                    tooltip={trans().ads.list.sorting.label}
                    className="with-icon-flex gap-2"
                />
                <DropdownMenu shadow="2-strong">
                    {ItemsListSortingOptions.map((sort: ItemsListSorting) => (
                        <DropdownItem
                            key={sort}
                            className={sort === activeSort ? 'active' : undefined}
                            onClick={() => onChange(sort)}
                        >
                            {trans().ads.list.sorting.options[sort]}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}
